import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { PitchPlaylistSong } from './pitch-playlist.model';
import { Injectable } from '@angular/core';
import { Recording } from '../../../../../../../src/app/recordings/state';
import { SONGS_IN_PROJECT_PAGE_SIZE } from '../../../../../../../src/app/shared/projects/constants';
import { UserDivision } from '../../types';
import { Attachment } from '../../../../../../../src/app/shared/attachments/models/attachment.model';

export interface PitchPlaylistState extends EntityState<PitchPlaylistSong> {
  name: string;
  description?: string;
  clientNote?: string | null;
  expectedExpirationDate: string;
  isDownloadAllSupported: boolean;
  lastModifiedTime: string;
  createdBy: string;
  createdTime: string;
  userDivision: UserDivision;
  ui: {
    pitchNotFound: boolean;
    activeSong: Recording | null;
    expired: boolean;
    downloadAllSupported: boolean;
  };
  playlist: {
    recordingIds: [];
  };
  songsPager: {
    offset: number;
    limit: number;
    total: number;
  };
  attachments?: Attachment[];
}

@StoreConfig({
  name: 'PitchPlaylist',
  cache: {
    ttl: 3600000
  }
})
@Injectable({
  providedIn: 'root'
})
export class PitchPlaylistStore extends EntityStore<PitchPlaylistState, PitchPlaylistSong> {
  constructor() {
    super({
      loading: true,
      ui: {
        pitchNotFound: false,
        activeSong: null,
        expired: false,
        downloadAllSupported: true
      },
      playlist: {
        recordingIds: []
      },
      songsPager: {
        offset: 0,
        limit: SONGS_IN_PROJECT_PAGE_SIZE,
        total: 0
      }
    });
  }
}
